// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
    border: 1px solid;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    flex-direction: column;
}

.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 5px;
    display: flex;
    flex-direction: column;
}

.message-input-container {
    display: flex;
    margin-top: 10px;
    padding-top: 10px;
}

.message-input-field {
    flex: 1;
    padding: 8px;
    border: 1px solid;
    border-radius: 4px;
    margin-right: 5px;
}

.message-input-field:focus {
    outline: none;
}

.message-input-button {
    background-color: #007bff;
    color: white;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.message-input-container .disabled {
    background-color: #efefef4d;
    color: #1010104d;
    border-color: #efefef4d;
    cursor: auto;
}

.message-input-button:hover {
    background-color: #0056b3;
}

.message-input-container .disabled:hover {
    background-color: #efefef4d;
}

.chat-bubble {
    max-width: 75%;
    margin-bottom: 10px;
    padding: 0px 10px 0px;
    border-radius: 12px;
    word-wrap: break-word;
}

.user .markdown-content a {
    color: #fff;
    text-decoration: underline;
}

.user .markdown-content a:hover {
    color: #212427;
}

.markdown-content code {
    background-color: rgba(0, 0, 0, 0.4);
    color: #ffffffda;
    padding: 2px 4px;
    border-radius: 4px;
}

.empty-chat {
    margin: 0 auto;
}

.actionBtnContainer {
    position: relative;
}

.dotsButton {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.dotsButton:hover {
    background: #cccccc1f;
    border-radius: 50%;
    cursor: pointer;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdownMenu {
    position: absolute;
    background-color: white;
    width: 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.dropdownItem {
    padding: 8px 12px;
    background: none;
    border: none;
    text-align: left;
    width: 100%;
    cursor: pointer;
}

.dropdownItem:hover {
    background-color: #f1f1f1;
}

`, "",{"version":3,"sources":["webpack://./src/styles/chatStyles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".chat-container {\n    border: 1px solid;\n    border-radius: 8px;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.chat-messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n}\n\n.message-input-container {\n    display: flex;\n    margin-top: 10px;\n    padding-top: 10px;\n}\n\n.message-input-field {\n    flex: 1;\n    padding: 8px;\n    border: 1px solid;\n    border-radius: 4px;\n    margin-right: 5px;\n}\n\n.message-input-field:focus {\n    outline: none;\n}\n\n.message-input-button {\n    background-color: #007bff;\n    color: white;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.message-input-container .disabled {\n    background-color: #efefef4d;\n    color: #1010104d;\n    border-color: #efefef4d;\n    cursor: auto;\n}\n\n.message-input-button:hover {\n    background-color: #0056b3;\n}\n\n.message-input-container .disabled:hover {\n    background-color: #efefef4d;\n}\n\n.chat-bubble {\n    max-width: 75%;\n    margin-bottom: 10px;\n    padding: 0px 10px 0px;\n    border-radius: 12px;\n    word-wrap: break-word;\n}\n\n.user .markdown-content a {\n    color: #fff;\n    text-decoration: underline;\n}\n\n.user .markdown-content a:hover {\n    color: #212427;\n}\n\n.markdown-content code {\n    background-color: rgba(0, 0, 0, 0.4);\n    color: #ffffffda;\n    padding: 2px 4px;\n    border-radius: 4px;\n}\n\n.empty-chat {\n    margin: 0 auto;\n}\n\n.actionBtnContainer {\n    position: relative;\n}\n\n.dotsButton {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n}\n\n.dotsButton:hover {\n    background: #cccccc1f;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdownMenu {\n    position: absolute;\n    background-color: white;\n    width: 100px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n.dropdownItem {\n    padding: 8px 12px;\n    background: none;\n    border: none;\n    text-align: left;\n    width: 100%;\n    cursor: pointer;\n}\n\n.dropdownItem:hover {\n    background-color: #f1f1f1;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
